<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M21 7q1 1.2 1 2.7v8.6a3.7 3.7 0 0 1-3.7 3.7H9.7A3.7 3.7 0 0 1 6 18.3V9.6A3.7 3.7 0 0 1 9.7 6h8.6Q20 6 21 7"
    />
    <path
      d="M17.4 3.5a1 1 0 0 1-1.8 1q-.2-.6-.6-.5H5a1 1 0 0 0-1 1v10q0 .6.5.9a1 1 0 1 1-1 1.7A3 3 0 0 1 2 15V5a3 3 0 0 1 3-3h10q1.5 0 2.4 1.5"
    />
  </svg>
</template>
